/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'

const TimelineLazyRouteImport = createFileRoute('/_timeline')()
const TimelineIndexLazyRouteImport = createFileRoute('/_timeline/')()
const AlbumAlbumIdLazyRouteImport = createFileRoute('/album/$albumId')()
const AlbumAlbumIdIndexLazyRouteImport = createFileRoute('/album/$albumId/')()
const TimelinePhotoPhotoIdLazyRouteImport = createFileRoute(
  '/_timeline/photo/$photoId',
)()
const AlbumAlbumIdPhotoPhotoIdLazyRouteImport = createFileRoute(
  '/album/$albumId/photo/$photoId',
)()

const TimelineLazyRoute = TimelineLazyRouteImport.update({
  id: '/_timeline',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/_timeline.lazy').then((d) => d.Route))
const TimelineIndexLazyRoute = TimelineIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TimelineLazyRoute,
} as any).lazy(() =>
  import('./routes/_timeline.index.lazy').then((d) => d.Route),
)
const AlbumAlbumIdLazyRoute = AlbumAlbumIdLazyRouteImport.update({
  id: '/album/$albumId',
  path: '/album/$albumId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/album.$albumId.lazy').then((d) => d.Route),
)
const AlbumAlbumIdIndexLazyRoute = AlbumAlbumIdIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AlbumAlbumIdLazyRoute,
} as any).lazy(() =>
  import('./routes/album.$albumId.index.lazy').then((d) => d.Route),
)
const TimelinePhotoPhotoIdLazyRoute =
  TimelinePhotoPhotoIdLazyRouteImport.update({
    id: '/photo/$photoId',
    path: '/photo/$photoId',
    getParentRoute: () => TimelineLazyRoute,
  } as any).lazy(() =>
    import('./routes/_timeline.photo.$photoId.lazy').then((d) => d.Route),
  )
const AlbumAlbumIdPhotoPhotoIdLazyRoute =
  AlbumAlbumIdPhotoPhotoIdLazyRouteImport.update({
    id: '/photo/$photoId',
    path: '/photo/$photoId',
    getParentRoute: () => AlbumAlbumIdLazyRoute,
  } as any).lazy(() =>
    import('./routes/album.$albumId.photo.$photoId.lazy').then((d) => d.Route),
  )

export interface FileRoutesByFullPath {
  '/': typeof TimelineIndexLazyRoute
  '/album/$albumId': typeof AlbumAlbumIdLazyRouteWithChildren
  '/photo/$photoId': typeof TimelinePhotoPhotoIdLazyRoute
  '/album/$albumId/': typeof AlbumAlbumIdIndexLazyRoute
  '/album/$albumId/photo/$photoId': typeof AlbumAlbumIdPhotoPhotoIdLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof TimelineIndexLazyRoute
  '/photo/$photoId': typeof TimelinePhotoPhotoIdLazyRoute
  '/album/$albumId': typeof AlbumAlbumIdIndexLazyRoute
  '/album/$albumId/photo/$photoId': typeof AlbumAlbumIdPhotoPhotoIdLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_timeline': typeof TimelineLazyRouteWithChildren
  '/album/$albumId': typeof AlbumAlbumIdLazyRouteWithChildren
  '/_timeline/': typeof TimelineIndexLazyRoute
  '/_timeline/photo/$photoId': typeof TimelinePhotoPhotoIdLazyRoute
  '/album/$albumId/': typeof AlbumAlbumIdIndexLazyRoute
  '/album/$albumId/photo/$photoId': typeof AlbumAlbumIdPhotoPhotoIdLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/album/$albumId'
    | '/photo/$photoId'
    | '/album/$albumId/'
    | '/album/$albumId/photo/$photoId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/photo/$photoId'
    | '/album/$albumId'
    | '/album/$albumId/photo/$photoId'
  id:
    | '__root__'
    | '/_timeline'
    | '/album/$albumId'
    | '/_timeline/'
    | '/_timeline/photo/$photoId'
    | '/album/$albumId/'
    | '/album/$albumId/photo/$photoId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  TimelineLazyRoute: typeof TimelineLazyRouteWithChildren
  AlbumAlbumIdLazyRoute: typeof AlbumAlbumIdLazyRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_timeline': {
      id: '/_timeline'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof TimelineLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_timeline/': {
      id: '/_timeline/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof TimelineIndexLazyRouteImport
      parentRoute: typeof TimelineLazyRoute
    }
    '/album/$albumId': {
      id: '/album/$albumId'
      path: '/album/$albumId'
      fullPath: '/album/$albumId'
      preLoaderRoute: typeof AlbumAlbumIdLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/album/$albumId/': {
      id: '/album/$albumId/'
      path: '/'
      fullPath: '/album/$albumId/'
      preLoaderRoute: typeof AlbumAlbumIdIndexLazyRouteImport
      parentRoute: typeof AlbumAlbumIdLazyRoute
    }
    '/_timeline/photo/$photoId': {
      id: '/_timeline/photo/$photoId'
      path: '/photo/$photoId'
      fullPath: '/photo/$photoId'
      preLoaderRoute: typeof TimelinePhotoPhotoIdLazyRouteImport
      parentRoute: typeof TimelineLazyRoute
    }
    '/album/$albumId/photo/$photoId': {
      id: '/album/$albumId/photo/$photoId'
      path: '/photo/$photoId'
      fullPath: '/album/$albumId/photo/$photoId'
      preLoaderRoute: typeof AlbumAlbumIdPhotoPhotoIdLazyRouteImport
      parentRoute: typeof AlbumAlbumIdLazyRoute
    }
  }
}

interface TimelineLazyRouteChildren {
  TimelineIndexLazyRoute: typeof TimelineIndexLazyRoute
  TimelinePhotoPhotoIdLazyRoute: typeof TimelinePhotoPhotoIdLazyRoute
}

const TimelineLazyRouteChildren: TimelineLazyRouteChildren = {
  TimelineIndexLazyRoute: TimelineIndexLazyRoute,
  TimelinePhotoPhotoIdLazyRoute: TimelinePhotoPhotoIdLazyRoute,
}

const TimelineLazyRouteWithChildren = TimelineLazyRoute._addFileChildren(
  TimelineLazyRouteChildren,
)

interface AlbumAlbumIdLazyRouteChildren {
  AlbumAlbumIdIndexLazyRoute: typeof AlbumAlbumIdIndexLazyRoute
  AlbumAlbumIdPhotoPhotoIdLazyRoute: typeof AlbumAlbumIdPhotoPhotoIdLazyRoute
}

const AlbumAlbumIdLazyRouteChildren: AlbumAlbumIdLazyRouteChildren = {
  AlbumAlbumIdIndexLazyRoute: AlbumAlbumIdIndexLazyRoute,
  AlbumAlbumIdPhotoPhotoIdLazyRoute: AlbumAlbumIdPhotoPhotoIdLazyRoute,
}

const AlbumAlbumIdLazyRouteWithChildren =
  AlbumAlbumIdLazyRoute._addFileChildren(AlbumAlbumIdLazyRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  TimelineLazyRoute: TimelineLazyRouteWithChildren,
  AlbumAlbumIdLazyRoute: AlbumAlbumIdLazyRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
